import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import axios from 'axios';
import { BASE_URL } from '../../api/api';
import { useCookies } from 'react-cookie';

import Tablist from '../Tablist'
import '../../styles/componentsStyles/Profile/ChannelInfo.scss'

// import Logo from "../../assets/logos/codemmit-logo.png"
import ContentCard from '../ContentCard'

const ChannelInfo = () => {
    const [channelDetails, setchannelDetails] = useState({ channelName: "", logo: "", channelId: "", handle: "", about: "", followers: 0, posts: 0, ownerUserId: "" });
    const [cookies, setCookie] = useCookies(['token', 'userId', 'isLoggedIn', 'channelId']);
    const [activeTabContent, setActiveTabContent] = useState([]);

    // const { channelHandle } = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const channelId = queryParams.get('id');

    useEffect(() => {
        // const visitedChannelId = JSON.parse(window.sessionStorage.getItem("visitedChannelId"));
        // console.log(visitedChannelId, "visitedChannelId");
        const headers = {
            'Authorization': `${cookies.token}`
        };

        axios.post(`${BASE_URL}/api/channels/fetch-channel`, {
            channelId: channelId,
            requestingUserId: cookies.userId ? cookies.userId : "unknownUserWhoIsNotLoggedIn"
        }, {
            headers: headers
        }).then(res => {
            const data = res.data.channelData;
            console.log(res, "Channel Fetched")
            setchannelDetails({ ...channelDetails, channelName: data.channelName, about: data.about, handle: data.channelHandle, logo: data.logo, followers: data.followers, posts: data.posts, ownerUserId: data.ownerUserId })
        })
            .catch(err => console.log(err, "Error!, Fecthing channel details"))
    }, [])

    // function for updating content, (This function is called from Tablist Component in order to update the content)
    const fetchContent = () => {
        const activeTab = JSON.parse(window.sessionStorage.getItem("activeTabDetail"));
        axios.post(`${BASE_URL}/api/posts/fetch-posts`, { channelId: channelId, tabId: activeTab.id })
            .then(res => {
                if (res.data.statusText === "success") {
                    setActiveTabContent(res.data.posts);
                    console.log(res, "sgfsfgsggdf")
                } else {
                    console.log(res, "Error fetching posts")
                }
            })
            .catch(err => console.log(err, "Error fetching posts"))
    }

    return (
        <>
            <div className='channel-info'>
                <div className="channel-info__bio">
                    <div className="channel-info__logo-container">
                        <img className='channel-info__logo' src={channelDetails.logo} alt="logo" />
                    </div>
                    <div className="channel-info__about-channel">
                        <h5>{channelDetails.channelName}</h5>
                        <p>@{channelDetails.handle}  &#183; {channelDetails.followers} Followers  &#183; {channelDetails.posts} Posts</p>
                        <p>{channelDetails.about}</p>
                        <div className="channel-info__btn-container">
                            <Link to="/chat" className='channel-info__action-btn'>
                                Follow
                            </Link>
                            {/* <Link to="/chat" className='channel-info__action-btn'>
                                Message
                            </Link> */}
                        </div>
                    </div>
                </div>
                {/* <div className="channel-info__detail">
                    <div className='channel-info__numbers-container'>
                        <div className="channel-info__numbers">
                            <h4>6556</h4>
                            <p>Following</p>
                        </div>
                        <div className="channel-info__numbers">
                            <h4>1056</h4>
                            <p>Follower</p>
                        </div>
                        <div className="channel-info__numbers">
                            <h4>150</h4>
                            <p>Posts</p>
                        </div>
                    </div>

                    <button className='channel-info__follow-btn'>Follow</button>
                </div> */}
            </div>
            <Tablist fetchContentData={fetchContent} />
            <div className="channel-info__contents">
                {
                    activeTabContent.map(content => <ContentCard key={content.id} contentData={content} />)
                }
            </div>
        </>
    )
}

export default ChannelInfo